import { Autocomplete } from "@mui/material";
import { CustomStyledTextField } from "./ColoredTextfield";
import { AgMuiSelect } from "./AgMuiSelect";
import { useEffect, useRef, useState } from "react";
import { Controller } from "react-hook-form";
import Api from "../state/Api";
import Newapi from "../state/new-api";
import Utils from "../util/Utils";
import { enquiryStore } from "../enquiry/enquiry-data";
import { AgMuiSelect2 } from "./Controlled";


export default function AgAutoComplete({ options, name, control, rules, onBlur, onInputChange, selectedValue, fontSize, ...restProps }) {
  // const [inputValue, setInputValue] = useState('');
  //  const [options,setOptions] = useState([]);

  //  const fetchSuggestions = async (input) => {
  //   try {
  //     setLoading(true);
  //     // const response = await ;
  //     setSuggestions(response.data);
  //   } catch (error) {
  //     console.error('Error fetching suggestions:', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  //  const handleInputChange = (event, newValue) => {
  //   setInputValue(newValue);
  //   // if (newValue) {
  //   //   fetchSuggestions(newValue);
  //   // }
  // };
  // const [autocompleteOpen, setAutocompleteOpen] = useState(false);
  // useEffect(()=>{
  //    console.log("the options inside the ",options)
  //    if(options.length===0){
  //     // setAutocompleteOpen(false);
  //    }else{
  //     if(autocompleteOpen===false){
  //       setAutocompleteOpen(true);
  //     //  }else{
  //     //   setAutocompleteOpen(false);
  //     //   setAutocompleteOpen(true);
  //      }
  //    }
  // },[options])

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field, fieldState }) => <Autocomplete
    
        freeSolo={true}
        size="small"
        filterOptions={(menuoptions, state) => menuoptions}
        onBlur={() => {
          // setAutocompleteOpen(false);
          if (onBlur) {
            onBlur(field.value);
          }
        }}
        onChange={(e, val) => {
          field.onChange(val);
          if (selectedValue) {
            selectedValue(e, val);
          }
          // setAutocompleteOpen(false);
        }}
        onInputChange={(e) => {
          if (onInputChange) {
            onInputChange(e.target.value);
          }
        }}
        disablePortal
        options={options}
        sx={{ width: "100%" }}
        renderInput={(params) => <CustomStyledTextField  {...restProps} size="small" {...field} error={!!fieldState?.error} helperText={fieldState?.error?.message} {...params} fullWidth />}
      />}
    />
  );
}





export function AgMuiUn({ isDoor, validateAddress = false, rules, control, clearErrors, selectedValue,trigger, name, ...restProps }) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    console.log("The change is ")
    setOptions(() => []);
  }, [isDoor])

  // function checkcurrent() {
  //   if (record[name].length == 0) {
  //     return false
  //   } else {
  //     if (postcode.length == 0) {
  //       if (!Utils.checkAddress(record[name])) {
  //         return false
  //       } else {
  //         let a = record[name].split(' ')
  //         let l = false
  //         for (let i = 0; i < a.length; i++) {
  //           let k = a[i].replace(',', '').trim()
  //           if (Utils.checkZipcode(k)) {
  //             l = true
  //             i = a.length + 1
  //           }
  //         }
  //         if (!l) {
  //           let a = record[name].split(',')
  //           for (let i = 0; i < a.length; i++) {
  //             let k = a[i].trim()
  //             if (Utils.checkZipcode(k)) {
  //               l = true
  //               i = a.length + 1
  //             }
  //           }
  //         }
  //         if (!l) {
  //           return false
  //         } else {
  //           return true
  //         }
  //       }
  //     } else {
  //       return true
  //     }

  //   }
  // }




  const displaySuggestions = function (val) {
    if (val) {
      let d = [val,enquiryStore.current.shipmentType];
      if (d.length > 0) {
        Api.getMapUnloc({ descriptions: d }, setOptions)
      }
    }
  };


  const getdata = async (inputValue) => {
    if (inputValue && inputValue.length > 2) {
      let results
      let s = encodeURI(inputValue)
      let url = `${process.env.REACT_APP_API_SERVER}/api/v1/location/fetchaddress/${s}`
      results = await Newapi.get(url)
      return results;
    } else {
      return []
    }
  }

  function check(value) {
    let isError = false;
    if (value?.length > 0) {
      let l = Utils.getUNCodeFromLocationString(value);
      try {
        if (Utils.isUnLoc1(value)) {

          Api.checkUnloc(l, (data) => {
            isError = false;

            if (data == -1) {
              return
            } else {
              console.log("valid 2");
            }
          })
        } else {
          isError = true;

        }
      } catch (e) {
        console.log("the errror is ", e)
      }

    }
    if (isError) {
        return 'Please select an UN address'
    } else {
        return;
    }
  }

  const validateDoorAddress = (value) => {
    let isError = false;
    let postcode = "";
    let startIndex = value?.indexOf("[");
    let endIndex = value?.indexOf("]");

  
    if(endIndex===-1){
      return "* Pin/code is required"
    }
    if (startIndex > -1) {
      postcode = value.substring(startIndex + 1, value.length - 1).split(",")[2];
      if (!postcode) {
        postcode = "";
      }
    }else{
      return "* Pin/code is required"
    }

    if (isDoor && validateAddress) {
      if (!value || value?.length === 0) {
        isError = true;
      } else {
        if (postcode.length === 0) {
          if (!Utils.checkAddress(value)) {
            isError = true;
          } else {
            let a = value.split(' ')
            let l = false
            for (let i = 0; i < a.length; i++) {
              let k = a[i].replace(',', '').trim()
              if (Utils.checkZipcode(k)) {
                l = true
                i = a.length + 1
              }
            }
            if (!l) {
              console.log("the eroororo oo sosi s ",l)
              let a = value.split(',')
              for (let i = 0; i < a.length; i++) {
                let k = a[i].trim()
                if (Utils.checkZipcode(k)) {
                  l = true
                  i = a.length + 1
                }
              }
            }else{
              l = false
            }


            if (!l) {
              isError = true;
            } else {
              isError = false;
            }
          }
        } else {
          isError = false;
        }
      }
    }
    if (isError) {
        return "* Pin/code is required"
    } else {
        return;
    }
  }
  const handler = async (input) => {
    if (!isDoor) {
      displaySuggestions(input);
    }

    if (isDoor) {
     
      getdata(input).then((val) => {
        console.log("The value of the door is ", val);
        setOptions(val);
      })
    }

  }
  return <AgAutoComplete selectedValue={selectedValue} 
  onBlur={async(value) => {
     if(trigger){
        // await trigger(name);
     }
  }}
   rules={{
    ...rules,
    validate: (value) => {
      if (validateAddress) {
        if (isDoor) {
          return validateDoorAddress(value);
        } else {
          return check(value)
        }
      }
    }
  }} onInputChange={handler} control={control} name={name} options={options} {...restProps} />
}
